module.exports = __webpack_public_path__ + "static/media/user (8)new loanx3.6cef3805.svg";